module.exports = __webpack_public_path__ + "media/images/icon_url_copy-5a1276d6c92fcd14d0be9ff0c1b9393d.svg";